import { useClose } from "@headlessui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useDebouncedEffect } from "@react-hookz/web";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { TextInput, Typography } from "@/components/atoms";
import { useBookingFilters } from "../../../hooks/useBookingFilters";
import { FilterDrawer } from "../common/FilterDrawer";
import { FilterPopover } from "../common/FilterPopover";

const schema = z.object({
  company: z.string(),
});

type FormData = z.infer<typeof schema>;

export const CompanyFilter = () => {
  const {
    filters: { company },
    setFilter,
  } = useBookingFilters();

  const value = useMemo(() => company ?? "", [company]);

  const onClose = () => setFilter("company", undefined);

  return (
    <FilterPopover name="company" value={value} label="Company" onClose={onClose}>
      <CompanyFilterForm />
    </FilterPopover>
  );
};

interface CompanyFilterDrawerProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export const CompanyFilterDrawer = ({ open, onOpenChange }: CompanyFilterDrawerProps) => {
  const {
    filters: { company },
    setFilter,
  } = useBookingFilters();

  const value = useMemo(() => company ?? "", [company]);
  const onClose = () => setFilter("company", undefined);

  return (
    <FilterDrawer open={open} onOpenChange={onOpenChange} value={value} label="Company" onClose={onClose}>
      <CompanyFilterForm />
    </FilterDrawer>
  );
};

const CompanyFilterForm = () => {
  const close = useClose();

  const { setFilter, filters } = useBookingFilters();

  const { watch, register } = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: { company: filters.company ? filters.company : "" },
  });

  const value = watch("company");

  useDebouncedEffect(
    () => {
      setFilter("company", value);
    },
    [value],
    300
  );

  return (
    <form
      className="contents"
      onSubmit={(event) => {
        event.preventDefault();
        close();
      }}
    >
      <Typography className="mb-4">Search Company</Typography>
      <TextInput {...register("company")} size="md" iconName="SearchNormal1" placeholder="Search Company" />
    </form>
  );
};
